import React, { memo } from "react";

const AppImportIcon = ({ color = "#666666", className }) => {
	return (
		<svg className={className} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
			<path d="M12 3v12" />
			<path d="m8 11 4 4 4-4" />
			<path d="M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4" />
		</svg>
	);
};

export default memo(AppImportIcon);
